import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import "../styles/Navbar.css";
import HomeIcon from "../images/icon.png";

const HomeNavbar = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="header">
      <Navbar light expand="md">
        <NavbarBrand href="/">
          <img className="home_icon" src={HomeIcon} alt="" />
        </NavbarBrand>

        <NavbarToggler className="nav_toggler" onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto header__links" navbar>
            <NavItem>
              <NavLink className="nav_link" href="/">
                Home
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="nav_link" href="/services">
                Services
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="nav_link" href="/contact">
                Contact Us
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default HomeNavbar;
